export default "<div class=\"landing landing__not-found\">\n  <p>NOT FOUND</p>\n</div>"